<template>
    <div v-if="!loading">
        <slot name="dialog"></slot>
        <v-btn v-for="(btn,n) in btns" :key="n" 
            :color="btn.color" 
            class="mr-3"
            @click="changeStatus(btn.name)"
        >
            <T>{{ btn.text }}</T>
        </v-btn>
    </div>
    <div v-else>
        <v-tooltip bottom>
            <template v-slot:activator="{on, attrs}">
                <v-progress-circular indeterminate v-bind="attrs" v-on="on"/>
            </template>
            <span>{{ $t(sync_status.text) }}</span>
        </v-tooltip>
    </div>
</template>

<script>

export default{
    props:{
       btns: Array,
       active_status: String,
       sync_status: Object
    },
    data: ()=>({
    }),
    computed:{
        loading(){ 
            return this.active_status != "NEW" && this.sync_status.name == "WAIT" 
        }
    },
    methods:{
        changeStatus(status){
            // console.log('status', status)
            // console.log('active_status', this.active_status)
            // console.log('sync_status', this.sync_status)
            // console.log('btns', this.btns)
            this.$emit('changeStatus', status)
        }
    },
    mounted(){
    }
}
</script>